import IntroductionBanner from "./IntroductionBanner";
import Vision from "./Vision";
import Prize from "./Prize";
import CoreValue from "./CoreValue";
import HomeTeamOfExperts from "../Home-Page/views/HomeTeamOfExperts";
import CustomersPartners from "../Home-Page/views/CustomersPartners";
import Trip from "./Trip";
import Advise from "../Home-Page/views/Advise";
import CusPart from "../Home-Page/views/CuPart";

export default function Introduction() {
  return (
    <div className="pt-[71px] w-full">
      <IntroductionBanner />
      <Vision />
      <CoreValue />
      <Prize />

      <Trip />
      <HomeTeamOfExperts />
      <CustomersPartners />
      <CusPart />
      <Advise />
    </div>
  );
}
